import { UpOutlined } from '@teko/ds-icon';
import React__default, { useState, useCallback, useEffect } from 'react';
import styled from '@emotion/styled';

const BackToTop = ({
  position,
  zIndex,
  pageYOffset,
  className
}) => {
  const [show, setShow] = useState(!pageYOffset);
  const scrollToTop = () => {
    if (typeof window !== "undefined")
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };
  const checkScrollTop = useCallback(() => {
    if (typeof window !== "undefined") {
      if (!show && window.pageYOffset > pageYOffset) {
        setShow(true);
      } else if (show && window.pageYOffset <= pageYOffset) {
        setShow(false);
      }
    }
  }, [show]);
  useEffect(() => {
    if (typeof window !== "undefined")
      window.addEventListener("scroll", checkScrollTop);
    return () => {
      if (typeof window !== "undefined")
        window.removeEventListener("scroll", checkScrollTop);
    };
  }, [show]);
  return /* @__PURE__ */ React__default.createElement(StyledBackToTop, {
    position,
    zIndex,
    show,
    className
  }, /* @__PURE__ */ React__default.createElement(ScrollToTopBtn, {
    onClick: scrollToTop
  }, /* @__PURE__ */ React__default.createElement(UpOutlined, {
    size: 24,
    color: "primary"
  })));
};
const StyledBackToTop = styled.div(({ show, zIndex, position, theme }) => `
  display: ${show ? "block" : "none"};
  z-index: ${zIndex ? zIndex : 1030};
  position: fixed;
  ${position ? `
    ${position.bottom ? `bottom: ${position.bottom}rem;` : ""}
    ${position.top ? `top: ${position.top}rem;` : ""}
    ${position.left ? `left: ${position.left}rem;` : ""}
    ${position.right ? `right: ${position.right}rem;` : ""}
  ` : ""}
  cursor: pointer;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  &:hover {
    path[stroke],
    rect[stroke],
    line {
      stroke: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
  }
`);
const ScrollToTopBtn = styled.div(({ theme }) => `
  border-radius: 50%;
  background-color: ${theme == null ? void 0 : theme.colors.primary100};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
`);

export { BackToTop };
